<!-- <div
  [formGroup]="alFormGroup"
  class="h-100 w-100">
  <select
    [class]="alClass"
    [class.is-invalid]="
      (FormControl.invalid && FormControl.dirty) ||
      (FormControl.invalid && IsFormSubmitted)
    "
    [formControlName]="alFormControlName">
    <option
      selected
      [value]="null">
      {{ alPlaceHolder }}
    </option>
    <option
      *ngFor="let item of alDataList"
      [value]="item.value">
      {{ item.label }}
    </option>
  </select>
  {{ FormControl.value | json }}
  <div
    class="invalid-feedback"
    *ngIf="FormControl.invalid && IsFormSubmitted">
    {{ alName }} required
  </div>
</div> -->

@if(FormControl && FormControlName){
<select
    [class]="Class"
    [class.is-invalid]="(FormControl.invalid && FormControl.touched) || (FormControl.invalid && formSubmitted)"
    [formControl]="FormControl"
>
    <ng-content></ng-content>
</select>

<div class="invalid-feedback" *ngIf="FormControl.invalid">
    @if(ValidationMessages){ @for(item of ValidationMessages; track item){
    <div *ngIf="FormControl.hasError(item.validationName) != null">{{ item.validationMessage }}</div>
    } }
</div>
}
